import { Logger } from '../logger';
import { AdAPI } from './ad-api';
import { safeParseJson } from './ad-utils';
import cookie from 'js-cookie';

export enum AdExpType {
  AD_EXP_TYPE_SHORT_DRAMA_SWITCH = 'short_drama_switch', // 短剧播放详情页切换
  AD_EXP_TYPE_SHORT_DRAMA_COMMENT = 'short_drama_comment', // 短剧相关推荐请求
  AD_EXP_TYPE_SEARCH = 'search', // 搜索页广告
  AD_EXP_TYPE_GAME_QRCODE = 'game_qrcode', // 小游戏扫码
  AD_EXP_TYPE_GAME_REC_LIST = 'game_rec_list', // 小游戏推荐列表
  AD_EXP_TYPE_CHANNEL = 'channel', // 频道页
  AD_EXP_TYPE_VIDEO_DETAIL = 'video_detail', // 视频详情页
}

const logger = new Logger({
  name: 'ad-exps',
});

export class AdExp {
  public static expData: Record<AdExpType, string> | null = null;

  // 获取透传给SSP的实验ID,做联合实验用。飞流走ad_exp_ids，SSP接入走strategy_ids
  // 只提供给evo使用
  public static getSspExpIds(type: AdExpType): string[] {
    if (!this.expData) {
      const expJson = AdAPI.getRemoteConfig('pc_ad_ssp_exps', '');
      if (expJson === '') {
        this.expData = null;
        return [];
      }
      this.expData = safeParseJson(expJson);
      logger.log('[ad]getSspExpIds', expJson, this.expData);
    }
    const expData = this.expData!;
    if (type in expData && Array.isArray(expData[type])) {
      const expIds = [];
      const configNames = expData[type];
      for (const configName of configNames) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [_, remoteData] = AdAPI.getRemoteConfig2(configName, '');
        logger.log('[ad]getSspExpIds2', type, configName, remoteData);
        if (remoteData?.expName) {
          expIds.push(String(remoteData.expId));
        }
      }
      return expIds;
    }
    return [];
  }

  public static getWebExpIds(): string[] {
    return cookie.get('tab_experiment_str')?.split('#') || [];
  }

  // 获取飞流透传的ad_exp_ids字符串
  public static getVlAdExpIds(type: AdExpType): string {
    const expIds = import.meta.env.EVO ? this.getSspExpIds(type) : this.getWebExpIds();
    const str = expIds.join('+');
    logger.log('[ad]getVlAdExpIds', type, str);
    return str;
  }
}
